module.exports = __webpack_public_path__ + "static/media/greencow.44826e09.glb";